import type { CommunityData } from '@/types/database/communityData';

import { serviceLinks } from './constants';

export const sections = ['行程路線規劃', '交通工具動線查詢', '周邊美食娛樂'];

export const getServiceLink = (
  lifeService: CommunityData['lifeService'],
  currentLifeServicePage:
    | 'map'
    | 'bus'
    | 'train'
    | 'ubike'
    | 'MRT'
    | 'tour'
    | 'restaurant'
) => {
  const {
    locationInfo: { latitude, longitude, zoom },
    busUrl,
    trainUrl,
    MRT,
  } = lifeService;
  if (
    currentLifeServicePage &&
    (currentLifeServicePage === 'map' ||
      currentLifeServicePage === 'tour' ||
      currentLifeServicePage === 'restaurant')
  ) {
    return (
      serviceLinks[currentLifeServicePage] +
      `@${latitude},${longitude},${
        currentLifeServicePage !== 'tour' ? zoom : zoom - 2
      }z`
    );
  }
  if (currentLifeServicePage === 'bus') {
    return busUrl;
  }
  if (currentLifeServicePage === 'train') {
    return trainUrl;
  }
  if (currentLifeServicePage === 'MRT') {
    return MRT.url;
  }

  return serviceLinks[currentLifeServicePage];
};
